import {useMutation, useQuery, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";
import {computed, ref} from "vue";
import SweetToast from "@/SweetToast";

const crawlInProgress = ref(false);
const refetchInterval = computed(() => (crawlInProgress.value ? 1000 : false)); // Poll every 60s if crawling

const crawlStatusQuery = (websiteId) => useQuery({
  queryKey: ['action-crawl-status', websiteId],
  queryFn: async () => {
    const {data, status} = await axios.get(`/ajax/v2/website/${websiteId.value}/crawl-status`);

    if (status === 204) {
      crawlInProgress.value = false;

      return null;
    }

    crawlInProgress.value = true;
    return data.stage;
  },
  refetchInterval: refetchInterval,
  enabled: () => !!websiteId?.value,
});

const crawlLogQuery = () => useQuery({
  queryKey: ['crawl-log-details'],
  queryFn: async () => {
    const {data} = await axios.get('/ajax/v2/actions/crawl-log-details');

    return data.data;
  },
});

const recrawlMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (websiteId) => await axios.get(`/ajax/v2/website/${websiteId}/recrawl`),
    onSuccess: () => {
      SweetToast.fire({
        icon: 'success',
        title: 'The crawl has been successfully started.',
      });

      queryClient.invalidateQueries(['action-crawl-status']);
    },
    onError: ({response}) => {
      SweetToast.fire({
        icon: 'error',
        title: response.data.message ?? 'Something went wrong',
      });
    },
  });
};

export {
  crawlStatusQuery,
  crawlLogQuery,
  recrawlMutation,
  crawlInProgress,
};
